export enum HttpStatus {
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  PreconditionFailed = 412,
  ServerError = 500,
}
